// Tema: preferenza utente se esiste, altrimenti quella di sistema.
// Dichiarare il supporto al dark mode (color-scheme) disattiva anche l'Auto Dark
// Theme di Chrome/Google App, che altrimenti scurisce la pagina a modo suo e
// produce colori misti (sfondo chiaro + card scure, titoli invisibili).
const STORAGE_KEY = 'theme';

export function systemPrefersDark() {
  try {
    return window.matchMedia('(prefers-color-scheme: dark)').matches;
  } catch {
    return false;
  }
}

export function storedTheme() {
  try {
    const v = localStorage.getItem(STORAGE_KEY);
    return v === 'dark' || v === 'light' ? v : null;
  } catch {
    return null;
  }
}

export function getInitialTheme() {
  return storedTheme() || (systemPrefersDark() ? 'dark' : 'light');
}

const THEME_COLOR = { light: '#f7f9fc', dark: '#0b1120' };

export function applyTheme(theme) {
  const root = document.documentElement;
  root.classList.toggle('dark', theme === 'dark');
  root.style.colorScheme = theme;
  let meta = document.querySelector('meta[name="theme-color"]');
  if (!meta) {
    meta = document.createElement('meta');
    meta.setAttribute('name', 'theme-color');
    document.head.appendChild(meta);
  }
  meta.setAttribute('content', THEME_COLOR[theme] || THEME_COLOR.light);
}

export function persistTheme(theme) {
  try {
    localStorage.setItem(STORAGE_KEY, theme);
  } catch {}
}

// Segue il sistema finché l'utente non sceglie manualmente un tema.
export function watchSystemTheme(onChange) {
  try {
    const mq = window.matchMedia('(prefers-color-scheme: dark)');
    const handler = (e) => {
      if (!storedTheme()) onChange(e.matches ? 'dark' : 'light');
    };
    mq.addEventListener('change', handler);
    return () => mq.removeEventListener('change', handler);
  } catch {
    return () => {};
  }
}
